export default __webpack_public_path__ + "static/media/central_andes_2_5.8c22148c.JPG";